import { apiPaths } from '@/networking/api/ApiPaths';
import requestClient from '@/networking/api/RequestClient';
import { format } from 'date-fns';

//Action
//TODO
const AUCTION_BYID_FETCH_SUCCESS = 'AUCTION_BYID_FETCH_SUCCESS';
const AUCTION_DATA_FETCH_SUCCESS = 'AUCTION_DATA_FETCH_SUCCESS';
const AUCTION_DATA_FETCH_ERROR = 'AUCTION_DATA_FETCH_ERROR';
const AUCTION_BYID_FETCH_ERROR = 'AUCTION_BYID_FETCH_ERROR';
const CLEAR_AUCTION = 'CLEAR_AUCTION';

const initialState = {
    error: false,
    errorText: null,
    success: false,
    reload: false,
    auction: undefined,
    auctionData: undefined,
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {
        case AUCTION_BYID_FETCH_SUCCESS: return { ...state, error: false, auction: action.payload }
        case AUCTION_DATA_FETCH_SUCCESS: return { ...state, error: false, errorText: null, success: true, reload: !state.reload, auctionData: action.payload }
        case AUCTION_DATA_FETCH_ERROR: return { ...state, error: true, errorText: action.payload }
        case AUCTION_BYID_FETCH_ERROR: return { ...state, error: true, errorText: action.payload }
        case CLEAR_AUCTION: return { ...initialState }
        default: return state
    }
}

//Action creator
export const auctionByIdFetchSuccess = (auction: any) => {
    return { type: AUCTION_BYID_FETCH_SUCCESS, payload: auction }
}

export const auctionByIdFetchError = (errorText: string) => {
    return { type: AUCTION_BYID_FETCH_ERROR, payload: errorText }
}

export const auctionDataFetchSuccess = (auctionData: any) => {
    return { type: AUCTION_DATA_FETCH_SUCCESS, payload: auctionData }
}

export const auctionDataFetchError = (errorText: string) => {
    return { type: AUCTION_DATA_FETCH_ERROR, payload: errorText }
}

export const clearAuctionData = () => {
    return { type: CLEAR_AUCTION }
}

//Thunks
export const handleAuctionDataFetch = (onCompletedCallback?: (result: any) => void) => {

    return function (dispatch: any) {
        return requestClient.get(apiPaths.auction.retrieveAuctionPageData, null, null)
            .then(function (res) {
                if (res.success) {
                    dispatch(auctionDataFetchSuccess(res.response))
                } else {
                    dispatch(auctionDataFetchError(res.error))
                }

                if (onCompletedCallback) onCompletedCallback(res)
            })
    }
}

// Downloads the catalogue PDF (made on the server, like the admin portal's report downloads).
export const handleCatalogueDownload = (auctionId: string, onCompletedCallback?: (res: any) => void) => {
    // The user's local time with its offset, so the PDF shows the auction date and time in their time zone.
    const generatedAt = format(new Date(), "yyyy-MM-dd'T'HH:mm:ssxxx");

    return requestClient.get(apiPaths.auction.downloadCatalogue, null, { auctionId, generatedAt })
        .then(function (res) {
            if (res?.success && res.response?.data) {
                const binaryString = window.atob(res.response.data);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; ++i) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                const fileURL = URL.createObjectURL(new Blob([bytes], { type: res.response.contentType || 'application/pdf' }));

                const link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', res.response.filename || 'Catalogue.pdf');
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
                setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
            }

            if (onCompletedCallback) onCompletedCallback(res);
        });
}

export const handleAuctionByIdFetch = (auctionId: string, onCompletedCallback?: (res: any) => void) => {

    return function (dispatch: any) {
        return requestClient.get(apiPaths.auction.getById, null, { auctionId: auctionId })
            .then(function (res) {
                if (res.success) {
                    dispatch(auctionByIdFetchSuccess(res.response))
                } else {
                    dispatch(auctionByIdFetchError(res.error))
                }

                if (onCompletedCallback) onCompletedCallback(res);
            })
    }
}